export default function (number, pow = 1) {
	let factor = Math.pow(10, pow);
	return Math.round( number * factor ) / factor;
}
